"use strict";
var $dyn;
(function ($dyn) {
    var serverForm;
    (function (serverForm) {
        var InteractionChannelType;
        (function (InteractionChannelType) {
            InteractionChannelType["default"] = "default";
            InteractionChannelType["byRootId"] = "byRootId";
            InteractionChannelType["byElement"] = "byElement";
            InteractionChannelType["byChannel"] = "byChannel";
            InteractionChannelType["available"] = "available";
            InteractionChannelType["any"] = "any";
        })(InteractionChannelType = serverForm.InteractionChannelType || (serverForm.InteractionChannelType = {}));
        /**
         * Interaction channel.
         * @description Only responsible for queuing interactions TO the server through a reliableChannel (as before) and notifying when they are received back.
         */
        var InteractionChannel = /** @class */ (function () {
            /**
             * Initializes a new instance of the InteractionChannel class
             * @param channel The channel used to send interactions
             */
            function InteractionChannel(channel) {
                /** @internal */
                this.interactionQueue = [];
                /**
                 * Raised when an interaction is received via the reliable channel
                 * @yields IInteractionChannelInteractionReceivedEventArgs
                 * @internal
                 */
                this.interactionReceived = new $dyn.eventHost();
                this.channel = channel;
            }
            InteractionChannel.prototype.toString = function () {
                return "[channel: " + (this.channel.channelId === 0 ? "default" : this.channel.channelId) + ", pending: " + $dyn.length(this.interactionQueue) + "]";
            };
            InteractionChannel.prototype.setStaticLoadRequestComplete = function (targetElement) { };
            /**
             * Queue an interaction to be processed
             * @param interaction The interaction to be queued
             */
            InteractionChannel.prototype.queueInteraction = function (interaction) {
                $dyn.log.server && $dyn.log.server("ServerForm: Entering queueInteraction");
                if (!this.processingInteractions) {
                    if (interaction.windowId !== this.currentWindowId) {
                        // Flush the current interactions in the InteractionChannel (if any)
                        this.process(true);
                        $dyn.log.server &&
                            $dyn.log.server("InteractionChannel: Channel " +
                                this.channel.channelId +
                                " updating currentWindowId from " +
                                this.currentWindowId +
                                " to " +
                                interaction.windowId +
                                " in function sendInteractions.");
                        this.currentWindowId = interaction.windowId;
                    }
                    if (interaction.TargetId) {
                        // Clear any windowId off the interaction so we do not send it on the wire
                        interaction.windowId = undefined;
                        this.interactionQueue.push(interaction);
                        $dyn.log.server && $dyn.log.server("ServerForm: Queuing interaction: %o", interaction);
                        // We increment loading whenever an action is enqueued, and
                        // decrement as we push them into the outbound queue.
                        // However for interactions having autopostback false the client
                        // should not wait on its processing
                        if (interaction.NoAsyncIncrement === undefined || interaction.NoAsyncIncrement === null || interaction.NoAsyncIncrement !== true) {
                            $dyn.async.pending.increment("queue interaction");
                        }
                        // track the non thottled commands
                        if (!interaction.Throttle || !interaction.ThrottleValue) {
                            $dyn.async.nonThrottled++;
                        }
                    }
                    else {
                        $dyn.logError($dyn.format($dyn.label("ServerForm_MissingTargetId"), interaction));
                    }
                }
                else {
                    $dyn.logError($dyn.format($dyn.label("ServerForm_QueueError"), typeof interaction.details === "function" ? interaction.details() : interaction.$type));
                    $dyn.log.server && $dyn.log.server("ServerForm: Interaction %o", interaction);
                    if (interaction.FailureCallbackId) {
                        $dyn.serverForm.interactionManager.invokeCallback(interaction.FailureCallbackId);
                    }
                }
                $dyn.log.server && $dyn.log.server("ServerForm: Leaving queueInteraction");
            };
            /**
             * Queue a command interaction to be processed.
             * Parameters can be added to returned the command instance.
             * @obsolete unused in the entire codebase -- remove?
             * @param commandName The name of the command that supports interactions
             * @param targetId The ID of the interactable target for the command
             * @param rootId The ID of the interactable root for the command
             * @param callbackId An option callback ID that is executed when the command result is received from the other side
             * @param failureCallbackId A callback ID for the function to be called if the command gets dropped on the client or the server
             * @returns The queued instance of the interaction
             */
            InteractionChannel.prototype.queueCommandInteraction = function (commandName, targetId, rootId, callbackId, failureCallbackId) {
                // Create and add the command interaction to the queue
                var commandInteraction = {
                    $type: $dyn.serverForm.InteractionType.command,
                    CallbackId: callbackId,
                    CommandName: commandName,
                    FailureCallbackId: failureCallbackId,
                    TargetId: targetId,
                };
                commandInteraction.RootId = rootId;
                this.queueInteraction(commandInteraction);
                return commandInteraction;
            };
            /**
             * Queues a command interaction to be processed
             * @param interaction Interaction to queue
             */
            InteractionChannel.prototype.queueCallbackCommandInteraction = function (interaction) {
                this.queueInteraction(interaction);
            };
            /**
             * Queues a throttled command interaction to be processed
             * @param interaction The interaction to queue
             * @param callback Callback for the interaction
             */
            InteractionChannel.prototype.queueThrottledCommandInteraction = function (interaction, callback) {
                var resetThrottleTime = false;
                var removedInteraction = false;
                for (var i = 0, len = this.interactionQueue.length; i < len; i++) {
                    var queuedInteraction = this.interactionQueue[i];
                    // Remove existing throttled interactions from the same ThrottleId, unless the queued interaction should have been sent immediately.
                    if (queuedInteraction.Throttle && queuedInteraction.ThrottleId === interaction.ThrottleId && queuedInteraction.ThrottleValue > 0) {
                        if (!queuedInteraction.ResetThrottleTime) {
                            // Timestamp of the new interaction will take the timestamp of the queued interaction which will be removed
                            interaction.ThrottleTimestamp = queuedInteraction.ThrottleTimestamp;
                        }
                        // Remove existing interaction and enqueue new interaction
                        this.interactionQueue.splice(i, 1);
                        removedInteraction = true;
                        if (queuedInteraction.CallbackId) {
                            // Reuse the same CallbackId for the new interaction
                            interaction.CallbackId = queuedInteraction.CallbackId;
                        }
                        if (queuedInteraction.FailureCallbackId) {
                            // Reuse the same FailureCallbackId for the new interaction
                            interaction.FailureCallbackId = queuedInteraction.FailureCallbackId;
                        }
                        if (queuedInteraction.ThrottleCallback) {
                            // If throttle callback was specified call that here since the interaction is being removed due to throttling
                            queuedInteraction.ThrottleCallback();
                        }
                        $dyn.log.interactionThrottle && $dyn.log.interactionThrottle("InteractionThrottle: Interaction removed from the queue");
                        // Decrement loading as we remove this from the queue
                        if (queuedInteraction.NoAsyncIncrement === undefined || queuedInteraction.NoAsyncIncrement === null || queuedInteraction.NoAsyncIncrement !== true) {
                            $dyn.async.pending.decrement("dequeue interaction");
                            queuedInteraction.decrementWindowAsyncPending && queuedInteraction.decrementWindowAsyncPending();
                        }
                        // if there is only one interaction queued its the one we're replacing
                        // if the command has ResetThrottleTime set reset the delay
                        if (len === 1 && interaction.ResetThrottleTime) {
                            resetThrottleTime = true;
                        }
                        break;
                    }
                }
                if (resetThrottleTime) {
                    this._cancelDelayProcess();
                }
                $dyn.serverForm.interactionManager.registerCallback(interaction, callback);
                this.queueInteraction(interaction);
                // If we are resetting the throttle time, we have already canceled the previous delay so create a new one
                // If we are the first interaction in the queue of this type, create the delay process
                // If we are not the first and we are not resetting the throttle time, use the existing delay process
                // If the throttle value is zero then process immediately.
                if (interaction.ThrottleValue > 0) {
                    if (resetThrottleTime || !removedInteraction) {
                        this.delayProcess(interaction);
                    }
                }
                else {
                    this.process();
                }
            };
            InteractionChannel.prototype.removePendingPersonalization = function (targetId, property) {
                for (var i = 0, len = this.interactionQueue.length; i < len; i++) {
                    var queuedInteraction = this.interactionQueue[i];
                    if (queuedInteraction.CommandName === "PersistPersonalization" && queuedInteraction.TargetId === targetId && queuedInteraction.PositionalParameters[0] === property) {
                        this.interactionQueue.splice(i, 1);
                        break;
                    }
                }
            };
            /**
             * Processes all of the interactions in the queue
             * @param processImmediate Used to tell the reliableChannel to not batch interactions queued in the same event loop.
             */
            InteractionChannel.prototype.process = function (processImmediate) {
                $dyn.log.server && $dyn.log.server("ServerForm: Entering process");
                if (this.interactionQueue.length > 0 && !$dyn.flags.useDesignTimeView) {
                    if (!this.processingInteractions) {
                        this._interactionStart = window.performance.now();
                        var interactionsToSend = [];
                        var currentTimestamp = window.performance.now();
                        var sendTelemetry = false;
                        if (this.interactionQueue.length > 0) {
                            var interactions = this.interactionQueue;
                            interactionsToSend = [];
                            // Start from end of queue and move to the beginning
                            for (var i = interactions.length - 1; i >= 0; i--) {
                                var interaction = interactions[i];
                                if (!interaction.Throttle || currentTimestamp - interaction.ThrottleTimestamp >= interaction.ThrottleValue) {
                                    if (interaction.Telemetry) {
                                        sendTelemetry = true;
                                    }
                                    // send all interactions in front of it to outbound message queue
                                    interactionsToSend = interactions.slice(0, i + 1);
                                    // remove those interactions from the interaction queue
                                    this.interactionQueue.splice(0, i + 1);
                                    break;
                                }
                                else {
                                    $dyn.log.server && $dyn.log.server("ServerForm: Not processing interaction %o", interaction);
                                    $dyn.log.server && $dyn.log.server("Throttle Value: %s ms, Time spent in queue %s ms", interaction.ThrottleValue, currentTimestamp - interaction.ThrottleTimestamp);
                                }
                            }
                            // check for timing between when the interaction is queued and processed to validate when an interaction needs to be ExecuteImmediate
                            for (var i = 0, len = interactionsToSend.length; i < len; i++) {
                                var interaction = interactionsToSend[i];
                                if (interaction.beforeExecute) {
                                    interaction.beforeExecute();
                                }
                                if (interaction.ShouldBlockOnExecution) {
                                    var interactionName = interaction.CommandName ? interaction.CommandName : interaction.$type;
                                    if (typeof interaction.ShouldBlockDeferred === "function") {
                                        var shouldBlockDeferred = interaction.ShouldBlockDeferred();
                                        $dyn.log.blockUserInteraction &&
                                            $dyn.log.blockUserInteraction("BlockUserInteraction: InteractionChannel->Process - CommandName: %s is blocking. Immediate=%s", interaction.CommandName, !shouldBlockDeferred);
                                        $dyn.serverForm.interactionManager.incrementGlobalBlockingFlag(!shouldBlockDeferred, interactionName);
                                    }
                                    else {
                                        $dyn.log.blockUserInteraction &&
                                            $dyn.log.blockUserInteraction("BlockUserInteraction: InteractionChannel->Process - CommandName: %s is blocking. Immediate=%s", interaction.CommandName, !interaction.ShouldBlockDeferred);
                                        $dyn.serverForm.interactionManager.incrementGlobalBlockingFlag(!interaction.ShouldBlockDeferred, interactionName);
                                    }
                                }
                            }
                        }
                        $dyn.log.server && $dyn.log.server("ServerForm: Process interactions request (deferred)");
                        var queueWindowId = this.currentWindowId;
                        if (interactionsToSend.length > 0) {
                            if (sendTelemetry) {
                                // Insert an EventDataInteraction into the beginning of the queue.
                                $dyn.telemetry._addInteractions(interactionsToSend);
                            }
                            $dyn.log.server && $dyn.log.server("ServerForm: Processing interactions, Count: %d, %O", interactionsToSend.length, interactionsToSend);
                            this.channel.sendInteractions(interactionsToSend, queueWindowId, processImmediate);
                            $dyn.serverForm.resetSessionTimeout(false);
                            // Remove the number of interactions that we just sent
                            // from the loading count.
                            for (var i = 0, len = interactionsToSend.length; i < len; i++) {
                                if ((!interactionsToSend[i].Throttle || !interactionsToSend[i].ThrottleValue) &&
                                    (interactionsToSend[i].EventData === undefined || interactionsToSend[i].EventData === null)) {
                                    $dyn.async.nonThrottled--;
                                }
                                if (interactionsToSend[i].NoAsyncIncrement === undefined || interactionsToSend[i].NoAsyncIncrement === null || interactionsToSend[i].NoAsyncIncrement !== true) {
                                    $dyn.async.pending.decrement("dequeue interaction");
                                }
                            }
                            // reset the flag
                            $dyn.async.throttledCommandProcessing = false;
                        }
                    }
                    else {
                        $dyn.logWarning($dyn.format($dyn.label("ServerForm_ProcessError"), this.interactionQueue.length));
                        $dyn.log.server && $dyn.log.server("ServerForm: Interactions %o", this.interactionQueue);
                    }
                }
                $dyn.log.server && $dyn.log.server("ServerForm: Leaving process");
            };
            InteractionChannel.prototype.hasPendingResponse = function (onlyDataAffectingInteractions) {
                if (onlyDataAffectingInteractions === void 0) { onlyDataAffectingInteractions = false; }
                if (this.channel) {
                    return this.channel.hasPendingResponse(onlyDataAffectingInteractions);
                }
                return false;
            };
            InteractionChannel.prototype.registerInteractionReceivedCallback = function (callback, manager) {
                this.channel.interactionReceived.subscribe(this._onInteractionReceived.bind(this));
                this.interactionReceived.subscribe(callback.bind(manager));
            };
            InteractionChannel.prototype._cancelDelayProcess = function () {
                if (this._processingTimeout) {
                    this._processingTimeout.cancel();
                    $dyn.log.interactionThrottle && $dyn.log.interactionThrottle("InteractionThrottle: InteractionChannel->delayProcess - Cancel timeout");
                }
            };
            /**
             * Triggers processing all of the interactions in the queue after a delay
             * @param interaction Interaction to delay
             */
            InteractionChannel.prototype.delayProcess = function (interaction) {
                var _this = this;
                // Start a one time timer to process the queue in order to ensure this
                // interaction is processed. We pad the throttle timeout slightly
                // because occasionally window.setTimeout will fire the callback too
                // early. If throttleValue is 0 then process immediately.
                // TODO: bug 1552552 addresses looking at this more closely and
                // determining a more thorough fix.
                var delay = interaction.ThrottleValue;
                interaction.ThrottleTimestamp = window.performance.now();
                this._processingTimeout = $dyn.async(function () {
                    $dyn.log.interactionThrottle && $dyn.log.interactionThrottle("InteractionThrottle: InteractionChannel->delayProcess - Timeout called");
                    $dyn.async.throttledCommandProcessing = true;
                    _this.process();
                }, parseInt(delay, 10) + 50, "InteractionThrottle: InteractionChannel->delayProcess");
                $dyn.log.server && $dyn.log.server("ServerForm: Leaving delayProcess");
            };
            InteractionChannel.prototype._onInteractionReceived = function (args) {
                // Mutate the type of the event args from the reliable channel to the interaction channel
                var outboundArgs = args;
                outboundArgs.Channel = this;
                this.interactionReceived.raise(outboundArgs);
            };
            return InteractionChannel;
        }());
        serverForm.InteractionChannel = InteractionChannel;
    })(serverForm = $dyn.serverForm || ($dyn.serverForm = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=InteractionChannel.js.map
